import { useTranslation } from "react-i18next";
import InitContext from "../pages/InitContext";
import React, { useContext, useEffect, useState } from "react";
import useMmcService from "../../services/MmcService";
import ErrorMessage from "../errorMessage/ErrorMessage";
import Spinner from "../spinner/Spinner";
import Disease from "../disease/Disease";
import MedicalData from "./MedicalData";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus, faTrash} from "@fortawesome/free-solid-svg-icons";
import {Consts} from "../pages/consts";

const Patient = () => {
  const { t } = useTranslation();
  const [patientDiseases, setPatientDiseases] = useState([]);
  const [patientsDiseasesInDb, setPatientsDiseasesInDb] = useState([]);
  const context = useContext(InitContext);
  const [openAddDisease, setOpenAddDisease] = useState(false);
  const [patient, setPatient] = useState({});
  const [alreadyAddedError, setAlreadyAddedError] = useState(false);
  const { loading, error, clearError, getDbUser, getDbDiseases, deleteDbDisease, saveDbDisease } = useMmcService();

  useEffect(() => {
    clearError();
    getDbUser(context?.token, context?.patient?.id).then((patient) => setPatient(patient));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    clearError();

    if (patient?.id) {
      getDbDiseases(context?.token, patient?.id).then((data) =>
        setPatientsDiseasesInDb(data?.diseases));
    }
  }, [patient]);

  const handleDeleteDisease = (disease) => {
    if(disease?.id){ // the disease to delete was stored in the DB
      deleteDbDisease(context?.token, disease?.id).then((result) => {
        const newDiseases = diseasesToShow?.filter(d  => d?.id !== result?.id);
        setPatientsDiseasesInDb(newDiseases);
        setPatientDiseases([]);
      });
    } else { // the disease to delete is a new one, which is not yet stored in the DB
      const newDiseases = patientDiseases?.filter(d  => d?.icd10 !== disease?.icd10);
      setPatientDiseases(newDiseases);
    }
  };

  const saveDiseases = () => {
    clearError();

    patientDiseases?.forEach((disease) => {
      if (context?.token && context?.token !== "") {
        saveDbDisease(context?.token, disease, context?.patient?.id).then(
          () => {
            disease = {...disease};
            setPatientsDiseasesInDb([...patientsDiseasesInDb, disease])
            setPatientDiseases([]);
          }
        );
      }
    });
  }

  let message =
    error && error?.includes(Consts.PATIENT)
      ? error && error?.includes(Consts.GET)
        ? t("error_by_retrieving_patients_data")
        : t("error_by_updating_patients_data")
      : error && error?.includes(Consts.MEASUREMENT)
        ? error && error?.includes(Consts.GET)
          ? t("error_by_retrieving_patients_measurements")
          : t("error_by_saving_a_measurement")
        : t("error_by_retrieving_a_disease");

  const errorMessage = error && <ErrorMessage message={message} />;
  const spinner = loading && <Spinner />;
  let diseasesToShow = [];

  if(patientsDiseasesInDb?.length > 0){
    diseasesToShow = [...patientsDiseasesInDb];
  }

  if(patientDiseases?.length > 0){
    diseasesToShow = [...diseasesToShow, ...patientDiseases];
  }

  const localErrorMessage = alreadyAddedError && (
    <ErrorMessage message="The disease is already selected" />
  );

  return (
    <div className="w3-display-container content-container">
      <div style={{ width: '100%', textAlign: 'right', paddingRight: "20px" }}>
        <label>{t("username")}: {context?.patient?.login}, {t("role")}: {t("patient").toLowerCase()}</label>
      </div>
      <div className="w3-display-middle form-display record-panel">
        <header className="w3-container w3-center w3-padding-small">
          <h2>{t("your_medical_data")}</h2>
        </header>
        {errorMessage}
        {localErrorMessage}
        {spinner}
        <div className="w3-container">
          <div className="w3-column w3-padding-small ">
            <div className="w3-container">
              <MedicalData patient={patient} />
            </div>
            <div className="w3-col m11 w3-margin-left w3-margin-top">
              <div
                className="diseases-scroll w3-margin-left w3-margin-bottom"
                style={{ backgroundColor: "#FFFFE0" }}
              >
                <h3 style={{ paddingLeft: "12px" }}>{t("your_diseases")}</h3>
                <ul style={{ listStyleType: Consts.NONE, padding: "12px" }}>
                  {diseasesToShow?.map((disease) => (
                    <li
                      key={disease?.icd10}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginBottom: "10px",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span style={{ minWidth: "150px" }}>
                        {disease?.icd10name} ({disease?.icd10})
                      </span>
                      <button
                        type="button"
                        onClick={() => handleDeleteDisease(disease)}
                        className="w3-btn w3-round-xlarge w3-theme-d5 "
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="w3-right w3-padding-small w3-margin-bottom">
                <div
                  className="w3-btn w3-round-xlarge w3-theme-d5"
                  onClick={() => setOpenAddDisease(true)}
                >
                  <FontAwesomeIcon icon={faPlus} /> {t("add_new_disease")}
                </div>
              </div>
              <div className="w3-right w3-padding-small ">
                <div
                  className={`w3-btn w3-round-xlarge w3-theme-d5 ${patientDiseases?.length > 0 ? "" : "w3-disabled"}`}
                  onClick={saveDiseases}
                >
                  {t("save_diseases")}
                </div>
              </div>
            </div>
            {openAddDisease && (
              <Disease
                showDialog={openAddDisease}
                closeDialog={() => setOpenAddDisease(false)}
                patientDiseases={patientDiseases}
                onSetPatientDiseases={setPatientDiseases}
                diseasesToShow={diseasesToShow}
                setAlreadyAddedError={value => setAlreadyAddedError(value)}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Patient;
